import { PermissionService } from '@business/services/permission_service';
import { useObservable } from '@core/utils/hooks/rxjs';
import { Session } from '@modules/auth/session';
import React, { memo } from 'react';
export interface HasBillingProps {
  children: React.ReactNode;
}

export const HasBilling = memo((props: HasBillingProps) => {
  const user = useObservable(Session.user$);

  if (!user) return null;

  return PermissionService.hasBilling(() => {
    return props.children;
  }, user);
});
